/**
 * Cossil Theme JavaScript
 *
 * @package Cossil
 */

import {
    createIcons,
    Leaf, Droplets, Trash2, Building2, Users, Lightbulb,
    Globe, Shield, Briefcase, GraduationCap, Heart, Star,
    CircleCheck, Clock, MapPin, TrendingUp,
    // Design & delivery
    PencilRuler, DraftingCompass, Ruler, LandPlot, HardHat, FileCheck, TrafficCone,
    // Energy & technology
    SolarPanel, BatteryCharging, EvCharger, PlugZap, Network, Waypoints,
    RadioTower, Cpu, Zap
} from 'lucide';

(function ($) {
    'use strict';

    // Document ready
    $(document).ready(function () {
        createIcons({
            icons: {
                Leaf, Droplets, Trash2, Building2, Users, Lightbulb,
                Globe, Shield, Briefcase, GraduationCap, Heart, Star,
                CircleCheck, Clock, MapPin, TrendingUp,
                PencilRuler, DraftingCompass, Ruler, LandPlot, HardHat, FileCheck, TrafficCone,
                SolarPanel, BatteryCharging, EvCharger, PlugZap, Network, Waypoints,
                RadioTower, Cpu, Zap
            }
        });
        initMobileMenu();
        initStickyHeader();
        initAnchorScrollOffset();
        initSmoothScroll();
        initDropdownAccessibility();
        initJobAccordion();
        initFaqAccordion();
        initProjectGallery();
        initProjectGalleryV3();
        initProjectFilters();
        initTeamFilters();
        initHeroSlider();
        initBlockGallery();
        initLogoCarousel();
        initIconGridCounter();
    });

    /**
     * Mobile menu toggle with full-screen overlay
     */
    function initMobileMenu() {
        const $menuToggle = $('#mobile-menu-toggle');
        const $menuClose = $('#mobile-menu-close');
        const $mobileMenu = $('#mobile-menu');
        const $body = $('body');

        // Open menu
        $menuToggle.on('click', function () {
            openMobileMenu();
        });

        // Close menu
        $menuClose.on('click', function () {
            closeMobileMenu();
        });

        // Close on escape key
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $mobileMenu.hasClass('is-open')) {
                closeMobileMenu();
            }
        });

        // Close when clicking outside menu content
        $mobileMenu.on('click', function (e) {
            if (e.target === this) {
                closeMobileMenu();
            }
        });

        // Close menu when clicking on a link
        $mobileMenu.find('a').on('click', function () {
            closeMobileMenu();
        });

        function openMobileMenu() {
            $mobileMenu.addClass('is-open');
            $mobileMenu.attr('aria-hidden', 'false');
            $menuToggle.attr('aria-expanded', 'true');
            $body.addClass('mobile-menu-open');

            // Prevent body scroll
            $body.css('overflow', 'hidden');

            // Focus first focusable element in menu
            setTimeout(function () {
                $menuClose.focus();
            }, 100);
        }

        function closeMobileMenu() {
            $mobileMenu.removeClass('is-open');
            $mobileMenu.attr('aria-hidden', 'true');
            $menuToggle.attr('aria-expanded', 'false');
            $body.removeClass('mobile-menu-open');

            // Restore body scroll
            $body.css('overflow', '');

            // Return focus to toggle button
            $menuToggle.focus();
        }
    }

    /**
     * Set scroll-padding-top on <html> equal to the fixed header height so all
     * anchor links (clicks, hash-on-load, back/forward) clear the header globally.
     */
    function initAnchorScrollOffset() {
        const header = document.querySelector('.site-header');
        if (!header) return;

        function update() {
            document.documentElement.style.scrollPaddingTop = header.offsetHeight + 20 + 'px';
        }

        update();
        window.addEventListener('resize', update);
    }

    /**
     * Sticky header with scroll detection
     */
    function initStickyHeader() {
        const $header = $('.site-header');
        const $body = $('body');
        let lastScrollTop = 0;
        const scrollThreshold = 50;
        let ticking = false;

        function updateHeader() {
            const scrollTop = $(window).scrollTop();

            // Add/remove scrolled class
            if (scrollTop > scrollThreshold) {
                $header.addClass('is-scrolled');
                $body.addClass('header-scrolled');
            } else {
                $header.removeClass('is-scrolled');
                $body.removeClass('header-scrolled');
            }

            // Optional: Hide header on scroll down, show on scroll up
            // Uncomment if desired
            /*
            if (scrollTop > lastScrollTop && scrollTop > 200) {
                // Scrolling down
                $header.addClass('is-hidden');
            } else {
                // Scrolling up
                $header.removeClass('is-hidden');
            }
            lastScrollTop = scrollTop;
            */

            ticking = false;
        }

        $(window).on('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    updateHeader();
                });
                ticking = true;
            }
        });

        // Initial check
        updateHeader();
    }

    /**
     * Smooth scroll for anchor links
     */
    function initSmoothScroll() {
        $('a[href^="#"]').on('click', function (e) {
            const hash = this.hash;

            // Skip if no hash or it's just "#"
            if (!hash || hash === '#') {
                return;
            }

            const target = $(hash);

            if (target.length) {
                e.preventDefault();

                // Calculate offset (header height + some padding)
                const headerHeight = $('.site-header').outerHeight() || 90;
                const offset = headerHeight + 20;

                $('html, body').animate(
                    {
                        scrollTop: target.offset().top - offset,
                    },
                    500,
                    function () {
                        // Update URL without jumping
                        if (history.pushState) {
                            history.pushState(null, null, hash);
                        }

                        // Set focus to target for accessibility
                        target.attr('tabindex', '-1').focus();
                    }
                );
            }
        });
    }

    /**
     * Keyboard accessibility for dropdown menus
     */
    function initDropdownAccessibility() {
        const $menuItems = $('.main-navigation .menu-item-has-children');

        $menuItems.each(function () {
            const $item = $(this);
            const $link = $item.children('a');
            const $submenu = $item.children('.sub-menu');

            // Toggle submenu on Enter/Space
            $link.on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    // If the link has a submenu, toggle it
                    if ($submenu.length) {
                        e.preventDefault();
                        $item.toggleClass('is-focused');

                        if ($item.hasClass('is-focused')) {
                            $submenu.find('a').first().focus();
                        }
                    }
                }

                // Arrow down opens submenu
                if (e.key === 'ArrowDown' && $submenu.length) {
                    e.preventDefault();
                    $item.addClass('is-focused');
                    $submenu.find('a').first().focus();
                }
            });

            // Handle submenu keyboard navigation
            $submenu.find('a').on('keydown', function (e) {
                const $links = $submenu.find('a');
                const currentIndex = $links.index(this);

                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (currentIndex < $links.length - 1) {
                            $links.eq(currentIndex + 1).focus();
                        }
                        break;

                    case 'ArrowUp':
                        e.preventDefault();
                        if (currentIndex > 0) {
                            $links.eq(currentIndex - 1).focus();
                        } else {
                            $link.focus();
                            $item.removeClass('is-focused');
                        }
                        break;

                    case 'Escape':
                        e.preventDefault();
                        $link.focus();
                        $item.removeClass('is-focused');
                        break;

                    case 'Tab':
                        if (e.shiftKey && currentIndex === 0) {
                            $item.removeClass('is-focused');
                        } else if (!e.shiftKey && currentIndex === $links.length - 1) {
                            $item.removeClass('is-focused');
                        }
                        break;
                }
            });

            // Close submenu when focus leaves
            $item.on('focusout', function (e) {
                // Check if the new focus target is within this menu item
                setTimeout(function () {
                    if (!$item.has(document.activeElement).length) {
                        $item.removeClass('is-focused');
                    }
                }, 10);
            });
        });

        // Add CSS for keyboard-focused state
        $('<style>')
            .text('.main-navigation .menu-item-has-children.is-focused > .sub-menu { opacity: 1; visibility: visible; }')
            .appendTo('head');
    }

    /**
     * Job listing accordion functionality
     */
    function initJobAccordion() {
        // New accordion triggers (Figma design)
        const $accordionTriggers = $('.job-listing__accordion-trigger');

        if ($accordionTriggers.length) {
            $accordionTriggers.on('click', function () {
                const $button = $(this);
                const $content = $button.next('.job-listing__accordion-content');
                const isExpanded = $button.attr('aria-expanded') === 'true';

                // Toggle this accordion item
                if (isExpanded) {
                    $button.attr('aria-expanded', 'false');
                    $content.attr('hidden', true);
                } else {
                    $button.attr('aria-expanded', 'true');
                    $content.removeAttr('hidden');
                }
            });

            // Keyboard accessibility for accordion
            $accordionTriggers.on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $(this).trigger('click');
                }
            });
        }

        // Legacy toggle button (backward compatibility)
        const $toggles = $('.job-listing__toggle');

        if ($toggles.length) {
            $toggles.on('click', function () {
                const $button = $(this);
                const $listing = $button.closest('.job-listing');
                const $details = $listing.find('.job-listing__details');
                const isExpanded = $button.attr('aria-expanded') === 'true';

                // Toggle this accordion
                if (isExpanded) {
                    $button.attr('aria-expanded', 'false');
                    $details.attr('hidden', true);
                    $button.find('.toggle-icon').css('transform', '');
                } else {
                    $button.attr('aria-expanded', 'true');
                    $details.removeAttr('hidden');
                    $button.find('.toggle-icon').css('transform', 'rotate(180deg)');

                    // Smooth scroll to show expanded content
                    setTimeout(function () {
                        const headerHeight = $('.site-header').outerHeight() || 90;
                        const listingTop = $listing.offset().top - headerHeight - 20;

                        if ($(window).scrollTop() > listingTop) {
                            $('html, body').animate({ scrollTop: listingTop }, 300);
                        }
                    }, 100);
                }
            });

            // Keyboard accessibility
            $toggles.on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $(this).trigger('click');
                }
            });
        }
    }

    /**
     * FAQ accordion block
     */
    function initFaqAccordion() {
        const $triggers = $('.faq-accordion__trigger');

        if (!$triggers.length) {
            return;
        }

        $triggers.on('click', function () {
            const $button = $(this);
            const $content = $button.next('.faq-accordion__content');
            const isExpanded = $button.attr('aria-expanded') === 'true';

            // Close all other items in the same accordion
            $button.closest('.faq-accordion').find('.faq-accordion__trigger').not($button).each(function () {
                $(this).attr('aria-expanded', 'false');
                $(this).next('.faq-accordion__content')[0].style.maxHeight = '0';
            });

            if (isExpanded) {
                $button.attr('aria-expanded', 'false');
                $content[0].style.maxHeight = '0';
            } else {
                $button.attr('aria-expanded', 'true');
                $content[0].style.maxHeight = $content[0].scrollHeight + 'px';
            }
        });

        $triggers.on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    }

    /**
     * Project gallery lightbox
     */
    function initProjectGallery() {
        const $gallery = $('#project-gallery');
        const $lightbox = $('#project-lightbox');

        if (!$gallery.length || !$lightbox.length) {
            return;
        }

        // Get gallery data
        const $galleryData = $('#gallery-data');
        let galleryImages = [];

        if ($galleryData.length) {
            try {
                galleryImages = JSON.parse($galleryData.text());
            } catch (e) {
                console.error('Failed to parse gallery data');
                return;
            }
        }

        if (!galleryImages.length) {
            return;
        }

        let currentIndex = 0;
        const $lightboxImage = $('#lightbox-image');
        const $lightboxCurrent = $('#lightbox-current');
        const $body = $('body');

        // Open lightbox on gallery item click
        $('.project-gallery__item').on('click', function () {
            currentIndex = parseInt($(this).data('index'), 10);
            openLightbox();
        });

        // Close lightbox
        $('.lightbox__close, .lightbox__backdrop').on('click', function () {
            closeLightbox();
        });

        // Navigate lightbox
        $('.lightbox__nav--prev').on('click', function () {
            navigateLightbox(-1);
        });

        $('.lightbox__nav--next').on('click', function () {
            navigateLightbox(1);
        });

        // Gallery navigation arrows
        $('.project-gallery__nav--prev').on('click', function () {
            scrollGallery(-1);
        });

        $('.project-gallery__nav--next').on('click', function () {
            scrollGallery(1);
        });

        // Keyboard navigation
        $(document).on('keydown', function (e) {
            if (!$lightbox.hasClass('is-open')) {
                return;
            }

            switch (e.key) {
                case 'Escape':
                    closeLightbox();
                    break;
                case 'ArrowLeft':
                    navigateLightbox(-1);
                    break;
                case 'ArrowRight':
                    navigateLightbox(1);
                    break;
            }
        });

        function openLightbox() {
            updateLightboxImage();
            $lightbox.addClass('is-open');
            $lightbox.attr('aria-hidden', 'false');
            $body.css('overflow', 'hidden');
            $('.lightbox__close').focus();
        }

        function closeLightbox() {
            $lightbox.removeClass('is-open');
            $lightbox.attr('aria-hidden', 'true');
            $body.css('overflow', '');
            $('.project-gallery__item').eq(currentIndex).focus();
        }

        function navigateLightbox(direction) {
            currentIndex += direction;

            if (currentIndex < 0) {
                currentIndex = galleryImages.length - 1;
            } else if (currentIndex >= galleryImages.length) {
                currentIndex = 0;
            }

            updateLightboxImage();
        }

        function updateLightboxImage() {
            const image = galleryImages[currentIndex];
            $lightboxImage.attr('src', image.full);
            $lightboxImage.attr('alt', image.alt);
            $lightboxCurrent.text(currentIndex + 1);
        }

        function scrollGallery(direction) {
            const $track = $('.project-gallery__track');
            const slideWidth = $('.project-gallery__slide').outerWidth(true);
            const currentScroll = $track.scrollLeft();
            const newScroll = currentScroll + (slideWidth * direction * 2);

            $track.animate({ scrollLeft: newScroll }, 300);
        }
    }

    /**
     * Project gallery V3 - thumbnail click to change main image, smart arrow visibility
     */
    function initProjectGalleryV3() {
        const $gallery = $('.project-gallery-v3');

        if (!$gallery.length) {
            return;
        }

        const $featuredImg = $gallery.find('.project-gallery-v3__featured-img');
        const $thumbnails = $gallery.find('.project-gallery-v3__thumb');
        const $track = $gallery.find('.project-gallery-v3__track');
        const $prevBtn = $gallery.find('.project-gallery-v3__nav-btn--prev');
        const $nextBtn = $gallery.find('.project-gallery-v3__nav-btn--next');
        const $lightbox = $('#project-lightbox');

        if (!$featuredImg.length || !$thumbnails.length) {
            return;
        }

        // Get gallery data for full-size images from JSON script tag
        const galleryDataEl = document.getElementById('gallery-data');
        let galleryImages = [];

        if (galleryDataEl) {
            try {
                const jsonText = galleryDataEl.textContent || galleryDataEl.innerHTML;
                galleryImages = JSON.parse(jsonText.trim());
            } catch (e) {
                console.error('Failed to parse gallery data:', e);
            }
        }

        // Build gallery data from thumbnail data attributes (most reliable)
        // This overrides JSON data as thumbnails have direct data-full-src attributes
        const thumbnailData = [];
        $thumbnails.each(function () {
            const $thumb = $(this);
            const $thumbImg = $thumb.find('img');
            const fullSrc = $thumb.data('full-src') || $thumb.attr('data-full-src');

            if (fullSrc) {
                thumbnailData.push({
                    full: fullSrc,
                    alt: $thumbImg.attr('alt') || ''
                });
            }
        });

        // Use thumbnail data if available, otherwise fall back to JSON
        if (thumbnailData.length) {
            galleryImages = thumbnailData;
        }

        let currentIndex = 0;

        // Thumbnail click - change main image
        $thumbnails.on('click', function (e) {
            e.preventDefault();
            const index = parseInt($(this).data('index'), 10);
            if (!isNaN(index)) {
                goToImage(index);
            }
        });

        // Navigation buttons - scroll thumbnails
        $prevBtn.on('click', function () {
            scrollThumbnails(-1);
        });

        $nextBtn.on('click', function () {
            scrollThumbnails(1);
        });

        // Featured image click - open lightbox
        $featuredImg.on('click', function () {
            if ($lightbox.length && galleryImages.length) {
                openLightbox(currentIndex);
            }
        });

        // Make featured image clickable
        $featuredImg.css('cursor', 'pointer');

        /**
         * Change the main featured image
         */
        function goToImage(index) {
            if (index < 0 || !galleryImages.length) {
                return;
            }

            // Clamp index to valid range
            index = Math.min(index, galleryImages.length - 1);

            const image = galleryImages[index];
            if (!image) return;

            // Update featured image with fade effect
            $featuredImg.fadeTo(150, 0.5, function () {
                $featuredImg.attr('src', image.full);
                $featuredImg.attr('alt', image.alt || '');
                $featuredImg.removeAttr('srcset').removeAttr('sizes');
            });

            // Fade back in when image loads
            $featuredImg.on('load', function () {
                $featuredImg.fadeTo(150, 1);
                $featuredImg.off('load');
            });

            // Update thumbnail active state
            $thumbnails.removeClass('is-active');
            $thumbnails.eq(index).addClass('is-active');

            // Scroll thumbnail into view if needed
            scrollThumbIntoView(index);

            currentIndex = index;
        }

        /**
         * Scroll thumbnails left/right
         */
        function scrollThumbnails(direction) {
            const thumbWidth = $thumbnails.first().outerWidth(true);
            const visibleWidth = $track.parent().width();
            const scrollAmount = Math.floor(visibleWidth / thumbWidth) * thumbWidth;
            const currentScroll = $track.scrollLeft();
            const newScroll = currentScroll + (scrollAmount * direction);

            $track.animate({ scrollLeft: newScroll }, 300, function () {
                updateArrowVisibility();
            });
        }

        /**
         * Scroll a specific thumbnail into view
         */
        function scrollThumbIntoView(index) {
            const $thumb = $thumbnails.eq(index);
            if (!$thumb.length) return;

            const trackLeft = $track.scrollLeft();
            const trackWidth = $track.parent().width();
            const thumbLeft = $thumb.position().left + trackLeft;
            const thumbWidth = $thumb.outerWidth(true);

            // Check if thumbnail is outside visible area
            if (thumbLeft < trackLeft) {
                // Scroll left to show thumbnail
                $track.animate({ scrollLeft: thumbLeft }, 200, updateArrowVisibility);
            } else if (thumbLeft + thumbWidth > trackLeft + trackWidth) {
                // Scroll right to show thumbnail
                $track.animate({ scrollLeft: thumbLeft - trackWidth + thumbWidth }, 200, updateArrowVisibility);
            }
        }

        /**
         * Update arrow visibility based on scroll position
         */
        function updateArrowVisibility() {
            const trackScrollWidth = $track[0].scrollWidth;
            const trackClientWidth = $track.parent().width();
            const scrollLeft = $track.scrollLeft();

            // Hide both arrows only if all thumbnails fit in view
            if (trackScrollWidth <= trackClientWidth) {
                $prevBtn.addClass('is-hidden');
                $nextBtn.addClass('is-hidden');
                return;
            }

            // Always show both buttons, but disable at boundaries
            $prevBtn.removeClass('is-hidden');
            $nextBtn.removeClass('is-hidden');

            // Disable prev at start
            if (scrollLeft <= 0) {
                $prevBtn.addClass('is-disabled').prop('disabled', true);
            } else {
                $prevBtn.removeClass('is-disabled').prop('disabled', false);
            }

            // Disable next at end
            if (scrollLeft + trackClientWidth >= trackScrollWidth - 1) {
                $nextBtn.addClass('is-disabled').prop('disabled', true);
            } else {
                $nextBtn.removeClass('is-disabled').prop('disabled', false);
            }
        }

        /**
         * Open lightbox at specific index
         */
        function openLightbox(index) {
            const $lightboxImage = $('#lightbox-image');
            const $lightboxCurrent = $('#lightbox-current');

            if (galleryImages[index]) {
                $lightboxImage.attr('src', galleryImages[index].full);
                $lightboxImage.attr('alt', galleryImages[index].alt || '');
                $lightboxCurrent.text(index + 1);
            }

            $lightbox.addClass('is-open');
            $lightbox.attr('aria-hidden', 'false');
            $('body').css('overflow', 'hidden');
            $('.lightbox__close').focus();
        }

        // Lightbox close button and backdrop
        $('.lightbox__close, .lightbox__backdrop').on('click', function () {
            $lightbox.removeClass('is-open');
            $lightbox.attr('aria-hidden', 'true');
            $('body').css('overflow', '');
        });

        // Lightbox prev/next navigation
        $('.lightbox__nav--prev').on('click', function () {
            currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
            openLightbox(currentIndex);
        });

        $('.lightbox__nav--next').on('click', function () {
            currentIndex = (currentIndex + 1) % galleryImages.length;
            openLightbox(currentIndex);
        });

        // Keyboard navigation
        $(document).on('keydown', function (e) {
            if ($lightbox.hasClass('is-open')) {
                // Lightbox keyboard navigation
                switch (e.key) {
                    case 'Escape':
                        $lightbox.removeClass('is-open');
                        $lightbox.attr('aria-hidden', 'true');
                        $('body').css('overflow', '');
                        break;
                    case 'ArrowLeft':
                        currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
                        openLightbox(currentIndex);
                        break;
                    case 'ArrowRight':
                        currentIndex = (currentIndex + 1) % galleryImages.length;
                        openLightbox(currentIndex);
                        break;
                }
                return;
            }

            // Only when gallery is in viewport and not in lightbox

            // Check if gallery is visible
            const galleryTop = $gallery.offset().top;
            const galleryBottom = galleryTop + $gallery.outerHeight();
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            if (galleryTop > viewportBottom || galleryBottom < viewportTop) {
                return;
            }

            if (e.key === 'ArrowLeft') {
                const prevIndex = Math.max(0, currentIndex - 1);
                goToImage(prevIndex);
            } else if (e.key === 'ArrowRight') {
                const nextIndex = Math.min(galleryImages.length - 1, currentIndex + 1);
                goToImage(nextIndex);
            }
        });

        // Set first thumbnail as active
        $thumbnails.first().addClass('is-active');

        // Initial arrow visibility check
        updateArrowVisibility();

        // Update on window resize
        $(window).on('resize', function () {
            updateArrowVisibility();
        });
    }

    /**
     * Project filters with AJAX
     */
    function initProjectFilters() {
        const $filterForm = $('#project-filters-form');
        const $gridSection = $('.section-projects-grid');

        if (!$filterForm.length) {
            return;
        }

        // Handle pill button clicks for location and status filters
        $filterForm.on('click', '.filter-pill', function (e) {
            e.preventDefault();
            const $pill = $(this);
            const $pillGroup = $pill.closest('.filter-group--pills');

            // Determine which filter type this is
            if (typeof $pill.data('location') !== 'undefined') {
                const location = $pill.data('location');

                // Update active state within this group only
                $pillGroup.find('.filter-pill').removeClass('is-active');
                $pill.addClass('is-active');
                // Update hidden input
                $filterForm.find('#filter-location').val(location);
            } else if (typeof $pill.data('sector') !== 'undefined') {
                const sector = $pill.data('sector');

                // Update active state within this group only
                $pillGroup.find('.filter-pill').removeClass('is-active');
                $pill.addClass('is-active');
                // Update hidden input
                $filterForm.find('#filter-sector').val(sector);
            }

            // Trigger AJAX filter
            triggerAjaxFilter();
        });

        // Handle clear link clicks
        $filterForm.on('click', '.filter-group__clear', function (e) {
            e.preventDefault();
            const $clearLink = $(this);
            const $filterGroup = $clearLink.closest('.filter-group');

            // Determine which filter to clear
            if ($filterGroup.hasClass('filter-group--pills')) {
                // Pill filter - reset to "All" within this group
                const $pills = $filterGroup.find('.filter-pill');
                $pills.removeClass('is-active');

                // Find the "All" pill (empty value) and activate it
                const $allPill = $pills.filter('[data-location=""], [data-sector=""]');
                $allPill.addClass('is-active');

                // Clear the corresponding hidden input
                const $hiddenInput = $filterGroup.find('input[type="hidden"]');
                $hiddenInput.val('');
            } else {
                // Select filter - reset to first option
                const $select = $filterGroup.find('select');
                $select.val('');
            }

            // Trigger AJAX filter
            triggerAjaxFilter();
        });

        // AJAX filter on select change
        $filterForm.on('change', 'select', function () {
            triggerAjaxFilter();
        });

        function triggerAjaxFilter() {
            const formData = $filterForm.serialize();
            const baseUrl = $filterForm.attr('action').split('#')[0];
            const newUrl = baseUrl + '?' + formData + '#project-filters';

            // Push datalayer event with all filter values
            pushProjectFilterEvent();

            // Update URL without reload
            window.history.pushState({ filters: formData }, '', newUrl);

            // Add loading state
            const $currentGrid = $('#projects-grid, .projects-empty');
            $currentGrid.css('opacity', '0.5');

            // Fetch filtered content
            $.ajax({
                url: newUrl,
                type: 'GET',
                success: function (response) {
                    const $response = $(response);
                    const $newGrid = $response.find('#projects-grid');
                    const $newPagination = $response.find('.pagination');
                    const $newEmpty = $response.find('.projects-empty');
                    const $newFilters = $response.find('#project-filters-form');

                    // Replace grid content
                    const $existingGrid = $('#projects-grid, .projects-empty');
                    if ($newGrid.length) {
                        $existingGrid.replaceWith($newGrid);
                    } else if ($newEmpty.length) {
                        $existingGrid.replaceWith($newEmpty);
                    }

                    // Update pagination
                    const $currentPagination = $gridSection.find('.pagination');
                    if ($newPagination.length) {
                        if ($currentPagination.length) {
                            $currentPagination.replaceWith($newPagination);
                        } else {
                            $gridSection.find('.container').append($newPagination);
                        }
                    } else {
                        $currentPagination.remove();
                    }

                    // Update filter title
                    const $newTitle = $response.find('.project-filters-header__title');
                    if ($newTitle.length) {
                        $('.project-filters-header__title').text($newTitle.text());
                    }

                    // Update clear buttons from new response
                    if ($newFilters.length) {
                        $newFilters.find('.filter-group').each(function (index) {
                            const $newGroup = $(this);
                            const $newClear = $newGroup.find('.filter-group__clear, .filter-group__clear--disabled').clone();
                            const $currentGroup = $filterForm.find('.filter-group').eq(index);
                            $currentGroup.find('.filter-group__clear, .filter-group__clear--disabled').replaceWith($newClear);
                        });
                    }
                },
                error: function () {
                    // Fallback to form submit on error
                    window.location.href = newUrl;
                },
                complete: function () {
                    // Get the new grid element and restore opacity
                    $('#projects-grid, .projects-empty').css('opacity', '1');
                }
            });
        }

        // Handle browser back/forward
        $(window).on('popstate', function (e) {
            if (e.originalEvent.state && e.originalEvent.state.filters) {
                location.reload();
            }
        });

        /**
         * Push project filter event to dataLayer with all current filter values
         */
        function pushProjectFilterEvent() {
            if (typeof window.dataLayer !== 'undefined') {
                const location = $filterForm.find('#filter-location').val() || '';
                const status = $filterForm.find('#filter-status').val() || '';
                const category = $filterForm.find('#filter-category').val() || '';
                const type = $filterForm.find('#filter-type').val() || '';

                window.dataLayer.push({
                    'event': 'filter_projects',
                    'search_location': location,
                    'search_status': status,
                    'search_category': category,
                    'search_type': type
                });
            }
        }
    }

    /**
     * Team page AJAX filters
     */
    function initTeamFilters() {
        const $filterButtons = $('.team-filter__buttons .filter-btn');
        const $teamGrid = $('#team-grid');
        const $gridSection = $('.section-team-grid');

        if (!$filterButtons.length || !$teamGrid.length) {
            return;
        }

        $filterButtons.on('click', function (e) {
            e.preventDefault();

            const $btn = $(this);
            const newUrl = $btn.attr('href').replace('#team-filter', '');
            const filterLabel = $btn.text().trim();

            // Update active state
            $filterButtons.removeClass('is-active');
            $btn.addClass('is-active');

            // Push datalayer event
            if (typeof window.dataLayer !== 'undefined') {
                // Extract location value from URL or button data
                const locationMatch = newUrl.match(/location=([^&]*)/);
                const location = locationMatch ? locationMatch[1] : '';

                window.dataLayer.push({
                    'event': 'filter_team',
                    'search_location': location
                });
            }

            // Update URL without reload
            window.history.pushState({ teamFilter: true }, '', newUrl || window.location.pathname);

            // Add loading state
            $teamGrid.css('opacity', '0.5');

            // Fetch filtered content
            $.ajax({
                url: newUrl || window.location.pathname,
                type: 'GET',
                success: function (response) {
                    const $response = $(response);
                    const $newGrid = $response.find('#team-grid');
                    const $newEmpty = $response.find('.team-empty');

                    // Replace grid content
                    if ($newGrid.length) {
                        $teamGrid.replaceWith($newGrid);
                    } else if ($newEmpty.length) {
                        $teamGrid.replaceWith($newEmpty);
                    }

                    // Re-initialize for new content
                    initTeamFilters();
                },
                error: function () {
                    // Fallback to link navigation on error
                    window.location.href = $btn.attr('href');
                },
                complete: function () {
                    $teamGrid.css('opacity', '1');
                }
            });
        });
    }

    /**
     * Hero slider functionality with video support
     */
    function initHeroSlider() {
        const $heroSliders = $('[data-hero-slider]');

        if (!$heroSliders.length) {
            return;
        }

        $heroSliders.each(function () {
            const $slider = $(this);
            const $slides = $slider.find('[data-slide-index]');
            const $tabs = $slider.find('[data-slide-target]');

            if ($slides.length <= 1) {
                // Single slide - just ensure video plays if present
                initVideoStates();
                return;
            }

            let currentIndex = 0;
            let autoplayInterval;
            const autoplayDelay = 6000; // 6 seconds

            // Tab click navigation
            $tabs.on('click', function () {
                const targetIndex = parseInt($(this).data('slide-target'), 10);
                goToSlide(targetIndex);
                resetAutoplay();
            });

            // Autoplay
            function startAutoplay() {
                autoplayInterval = setInterval(function () {
                    const nextIndex = (currentIndex + 1) % $slides.length;
                    goToSlide(nextIndex);
                }, autoplayDelay);
            }

            function resetAutoplay() {
                clearInterval(autoplayInterval);
                startAutoplay();
            }

            function goToSlide(index) {
                const $previousSlide = $slides.eq(currentIndex);
                const $nextSlide = $slides.eq(index);

                // Pause video on previous slide if it's a video slide
                pauseVideoOnSlide($previousSlide);

                // Update active states
                $slides.removeClass('is-active');
                $tabs.removeClass('is-active');

                $nextSlide.addClass('is-active');
                $tabs.eq(index).addClass('is-active');

                // Play video on new slide if it's a video slide
                playVideoOnSlide($nextSlide);

                currentIndex = index;
            }

            /**
             * Pause video on a slide
             */
            function pauseVideoOnSlide($slide) {
                if ($slide.data('slide-type') === 'video') {
                    const video = $slide.find('.block-hero__video')[0];
                    if (video) {
                        video.pause();
                    }
                }
            }

            /**
             * Play video on a slide
             */
            function playVideoOnSlide($slide) {
                if ($slide.data('slide-type') === 'video') {
                    const video = $slide.find('.block-hero__video')[0];
                    if (video) {
                        video.currentTime = 0;
                        video.play().catch(function(error) {
                            // Autoplay might be blocked, log but don't break
                            console.log('Video autoplay prevented:', error);
                        });
                    }
                }
            }

            /**
             * Initialize video states - pause non-active, play active
             */
            function initVideoStates() {
                $slides.each(function (index) {
                    const $slide = $(this);
                    if ($slide.data('slide-type') === 'video') {
                        const video = $slide.find('.block-hero__video')[0];
                        if (video) {
                            if (index === 0 || $slide.hasClass('is-active')) {
                                // First/active slide - ensure video plays
                                video.play().catch(function(error) {
                                    console.log('Initial video autoplay prevented:', error);
                                });
                            } else {
                                // Pause non-active videos
                                video.pause();
                            }
                        }
                    }
                });
            }

            // Initialize video states on load
            initVideoStates();

            // Start autoplay
            startAutoplay();

            // Pause on hover
            $slider.on('mouseenter', function () {
                clearInterval(autoplayInterval);
            });

            $slider.on('mouseleave', function () {
                startAutoplay();
            });

            // Keyboard navigation
            $slider.on('keydown', function (e) {
                if (e.key === 'ArrowLeft') {
                    const prevIndex = (currentIndex - 1 + $slides.length) % $slides.length;
                    goToSlide(prevIndex);
                    resetAutoplay();
                } else if (e.key === 'ArrowRight') {
                    const nextIndex = (currentIndex + 1) % $slides.length;
                    goToSlide(nextIndex);
                    resetAutoplay();
                }
            });
        });
    }

    /**
     * Block gallery functionality (carousel and grid with lightbox)
     */
    function initBlockGallery() {
        const $galleries = $('[data-gallery]');

        if (!$galleries.length) {
            return;
        }

        $galleries.each(function () {
            const $gallery = $(this);
            const $main = $gallery.find('[data-gallery-main]');
            const $currentImage = $gallery.find('[data-gallery-current]');
            const $thumbnails = $gallery.find('[data-gallery-thumb]');
            const $prevBtn = $gallery.find('[data-gallery-prev]');
            const $nextBtn = $gallery.find('[data-gallery-next]');

            if (!$thumbnails.length) {
                return;
            }

            let currentIndex = 0;

            // Thumbnail click
            $thumbnails.on('click', function () {
                const index = parseInt($(this).data('gallery-thumb'), 10);
                goToImage(index);
            });

            // Navigation buttons
            $prevBtn.on('click', function () {
                const prevIndex = (currentIndex - 1 + $thumbnails.length) % $thumbnails.length;
                goToImage(prevIndex);
            });

            $nextBtn.on('click', function () {
                const nextIndex = (currentIndex + 1) % $thumbnails.length;
                goToImage(nextIndex);
            });

            function goToImage(index) {
                const $thumb = $thumbnails.eq(index);
                const imageSrc = $thumb.data('image-src');
                const imageAlt = $thumb.data('image-alt');

                $currentImage.attr('src', imageSrc).attr('alt', imageAlt);

                $thumbnails.removeClass('is-active');
                $thumb.addClass('is-active');

                currentIndex = index;
            }

            // Keyboard navigation
            $gallery.on('keydown', function (e) {
                if (e.key === 'ArrowLeft') {
                    const prevIndex = (currentIndex - 1 + $thumbnails.length) % $thumbnails.length;
                    goToImage(prevIndex);
                } else if (e.key === 'ArrowRight') {
                    const nextIndex = (currentIndex + 1) % $thumbnails.length;
                    goToImage(nextIndex);
                }
            });
        });

        // Grid gallery lightbox
        const $gridItems = $('[data-lightbox-src]');

        if ($gridItems.length) {
            // Create lightbox if it doesn't exist
            if (!$('#block-lightbox').length) {
                const lightboxHtml = `
                    <div id="block-lightbox" class="block-lightbox" aria-hidden="true" role="dialog">
                        <div class="block-lightbox__backdrop"></div>
                        <div class="block-lightbox__content">
                            <button class="block-lightbox__close" aria-label="Close lightbox">&times;</button>
                            <img id="block-lightbox-image" class="block-lightbox__image" src="" alt="" />
                            <button class="block-lightbox__nav block-lightbox__nav--prev" aria-label="Previous image">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M15 18l-6-6 6-6"/>
                                </svg>
                            </button>
                            <button class="block-lightbox__nav block-lightbox__nav--next" aria-label="Next image">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M9 18l6-6-6-6"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                `;
                $('body').append(lightboxHtml);
            }

            const $lightbox = $('#block-lightbox');
            const $lightboxImage = $('#block-lightbox-image');
            let lightboxItems = [];
            let lightboxIndex = 0;

            // Build items array
            $gridItems.each(function (index) {
                lightboxItems.push({
                    src: $(this).data('lightbox-src'),
                    alt: $(this).data('lightbox-alt') || ''
                });
            });

            // Open lightbox
            $gridItems.on('click', function () {
                lightboxIndex = $gridItems.index(this);
                updateLightbox();
                $lightbox.addClass('is-open').attr('aria-hidden', 'false');
                $('body').css('overflow', 'hidden');
            });

            // Close lightbox
            $lightbox.on('click', '.block-lightbox__close, .block-lightbox__backdrop', function () {
                closeLightbox();
            });

            // Navigate
            $lightbox.on('click', '.block-lightbox__nav--prev', function () {
                lightboxIndex = (lightboxIndex - 1 + lightboxItems.length) % lightboxItems.length;
                updateLightbox();
            });

            $lightbox.on('click', '.block-lightbox__nav--next', function () {
                lightboxIndex = (lightboxIndex + 1) % lightboxItems.length;
                updateLightbox();
            });

            // Keyboard
            $(document).on('keydown', function (e) {
                if (!$lightbox.hasClass('is-open')) return;

                if (e.key === 'Escape') {
                    closeLightbox();
                } else if (e.key === 'ArrowLeft') {
                    lightboxIndex = (lightboxIndex - 1 + lightboxItems.length) % lightboxItems.length;
                    updateLightbox();
                } else if (e.key === 'ArrowRight') {
                    lightboxIndex = (lightboxIndex + 1) % lightboxItems.length;
                    updateLightbox();
                }
            });

            function updateLightbox() {
                const item = lightboxItems[lightboxIndex];
                $lightboxImage.attr('src', item.src).attr('alt', item.alt);
            }

            function closeLightbox() {
                $lightbox.removeClass('is-open').attr('aria-hidden', 'true');
                $('body').css('overflow', '');
            }
        }
    }

    /**
     * Logo carousel functionality (for multiple pages of logos)
     */
    function initLogoCarousel() {
        const $carousels = $('[data-logo-carousel]');

        if (!$carousels.length) {
            return;
        }

        $carousels.each(function () {
            const $carousel = $(this);
            const $pages = $carousel.find('[data-page]');
            const $indicators = $carousel.siblings('.logo-grid__indicators').find('.logo-grid__indicator');

            if ($pages.length <= 1) {
                return;
            }

            let currentIndex = 0;
            let autoplayInterval;
            const autoplayDelay = 5000; // 5 seconds

            // Indicator click navigation
            $indicators.on('click', function () {
                const targetIndex = parseInt($(this).data('target'), 10);
                goToPage(targetIndex);
                resetAutoplay();
            });

            // Autoplay
            function startAutoplay() {
                autoplayInterval = setInterval(function () {
                    const nextIndex = (currentIndex + 1) % $pages.length;
                    goToPage(nextIndex);
                }, autoplayDelay);
            }

            function resetAutoplay() {
                clearInterval(autoplayInterval);
                startAutoplay();
            }

            function goToPage(index) {
                $pages.removeClass('is-active');
                $indicators.removeClass('is-active');

                $pages.eq(index).addClass('is-active');
                $indicators.eq(index).addClass('is-active');

                currentIndex = index;
            }

            // Start autoplay
            startAutoplay();

            // Pause on hover
            $carousel.on('mouseenter', function () {
                clearInterval(autoplayInterval);
            });

            $carousel.on('mouseleave', function () {
                startAutoplay();
            });
        });
    }

    /**
     * Icon grid count-up animation for "By the Numbers" sections (VAR-004)
     * Targets .block-content-icon-grid--animated, parses numeric titles like "50+" or "35".
     */
    function initIconGridCounter() {
        const grids = document.querySelectorAll('.block-content-icon-grid--animated');
        if (!grids.length) return;

        function runCounter(grid) {
            grid.querySelectorAll('.block-content-icon-grid__title').forEach(function (el) {
                if (el.dataset.counted) return;
                el.dataset.counted = true;

                const text = el.textContent.trim();
                const match = text.match(/^(\d+)(.*)/);
                if (!match) return;

                const target = parseInt(match[1], 10);
                const suffix = match[2];
                if (!target) return;

                const duration = 1800;
                const start = performance.now();

                function tick(now) {
                    const progress = Math.min((now - start) / duration, 1);
                    const eased = 1 - Math.pow(1 - progress, 3);
                    el.textContent = Math.round(eased * target) + suffix;
                    if (progress < 1) requestAnimationFrame(tick);
                }
                requestAnimationFrame(tick);
            });
        }

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    runCounter(entry.target);
                    observer.unobserve(entry.target);
                });
            }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

            grids.forEach(function (grid) { observer.observe(grid); });
        } else {
            grids.forEach(runCounter);
        }
    }
})(jQuery);
